import { Fragment, useMemo } from 'react'
import Consts from 'consts'
import { useEnvironmentVariable } from 'shared/utils/envUtils'
import styled from '@emotion/styled'
import colors from 'design-system/tokens/colors'
import fontSizes from 'design-system/tokens/fontSizes'
import lineHeights from 'design-system/tokens/lineHeights'
import fontWeights from 'design-system/tokens/fontWeights'
import useLoggedInMenuItems from 'web-client/components/Header/LoggedIn/useLoggedInMenuItems'

const FooterWrapper = styled.footer`
  margin: 0;
  padding: 0;
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-direction: column;
`

const FooterList = styled.ul`
  padding: 0;
  text-align: center;
  display: flex;
  align-self: center;
  justify-content: center;
  width: 100%;
  margin: 0;
  gap: 10px;
`

const FooterItem = styled.li`
  display: inline-block;
  font-size: ${fontSizes.body};
  line-height: ${lineHeights.body};
  font-weight: ${fontWeights.normal};
  list-style: none;
  margin: 0;
  padding: 0;
  color: ${colors.black};
`

const FooterPointElement = styled(FooterItem)`
  line-height: ${lineHeights.body};
  font-weight: ${fontWeights.semibold};
  margin: 0;
  color: ${colors.grays.l1};
`

const Link = styled(FooterPointElement)`
  color: ${colors.primary};
  margin: 0;
  text-transform: uppercase;
`.withComponent('a')

const EnterpriseFooter = ({ className }: { className?: string }) => {
  const [{ PRIVACY_URL, TERMS_URL }] = useEnvironmentVariable<{
    PRIVACY_URL: string
    TERMS_URL: string
  }>(useMemo(() => [Consts.ENV_VAR.PRIVACY_URL, Consts.ENV_VAR.TERMS_URL], []))

  const menuItems = useLoggedInMenuItems()

  return (
    <FooterWrapper className={className}>
      {!!menuItems.length && (
        <FooterList>
          <FooterItem>Sitemap:</FooterItem>
          {menuItems.map((mI) => (
            <Fragment key={mI.title}>
              <Link href={mI.href} key={mI.title} title={mI.title}>
                {mI.title}
              </Link>
              <FooterPointElement>•</FooterPointElement>
            </Fragment>
          ))}
          <Link href="/settings" title="Settings">
            Settings
          </Link>
        </FooterList>
      )}
      <FooterList>
        <FooterItem>©{new Date().getFullYear()} Agero, Inc.</FooterItem>
        <FooterPointElement>•</FooterPointElement>
        <FooterItem>
          <Link href={PRIVACY_URL} rel="noopener noreferrer" target="_blank">
            PRIVACY
          </Link>
        </FooterItem>
        <FooterPointElement>•</FooterPointElement>
        <FooterItem>
          <Link href="/provider_terms_conditions" rel="noopener noreferrer" target="_blank">
            SERVICE PROVIDER TERMS
          </Link>
        </FooterItem>
        <FooterPointElement>•</FooterPointElement>
        <FooterItem>
          <Link href={TERMS_URL} rel="noopener noreferrer" target="_blank">
            AGERO TERMS
          </Link>
        </FooterItem>
      </FooterList>
    </FooterWrapper>
  )
}

export default EnterpriseFooter
